import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-symbol-icons',
  templateUrl: './symbol-icons.component.html',
  encapsulation: ViewEncapsulation.None
})
export class SymbolIconsComponent {}
